import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

export const keyPrefix = 'role_list_table_viewer';
export const useRoleListPageTranslation = (): UseTranslationResponse<'widgets', typeof keyPrefix> => useTranslation('widgets', { keyPrefix });
export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    table: {
      name: 'Название',
      description: 'Описание',
      role_id: 'ID роли',
      create_time: 'Создано',
      update_time: 'Изменено',
    },
    actions: {
      go_to_role: 'Перейти к роли',
      copy_role_id: 'Копировать',
      copied_role_id: 'Скопировано',
      duplicate_role: 'Дублировать',
      delete_role: 'Удалить',
    },
    toast: {
      delete_success: 'Роль успешно удалена',
      delete_error: 'Не удалось удалить роль',
    },
  },
}) : {}) as Record<string, unknown>;
export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    table: {
      name: 'Name',
      description: 'Description',
      role_id: 'Role ID',
      create_time: 'Created',
      update_time: 'Updated',
    },
    actions: {
      go_to_role: 'Go to role',
      copy_role_id: 'Copy',
      copied_role_id: 'Copied',
      duplicate_role: 'Duplicate',
      delete_role: 'Delete',
    },
    toast: {
      delete_success: 'Role deleted successfully',
      delete_error: 'Failed to delete role',
    },
  },
}) : {}) as Record<string, unknown>;
export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    table: {
      name: 'Nombre',
      description: 'Descripción',
      role_id: 'ID de rol',
      create_time: 'Creado',
      update_time: 'Actualizado',
    },
    actions: {
      go_to_role: 'Ir al rol',
      copy_role_id: 'Copiar',
      copied_role_id: 'Copiado',
      duplicate_role: 'Duplicar',
      delete_role: 'Eliminar',
    },
    toast: {
      delete_success: 'Rol eliminado correctamente',
      delete_error: 'No se pudo eliminar el rol',
    },
  },
}) : {}) as Record<string, unknown>;
export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    table: {
      name: 'Nome',
      description: 'Descrição',
      role_id: 'ID da função',
      create_time: 'Criado',
      update_time: 'Atualizado',
    },
    actions: {
      go_to_role: 'Ir para função',
      copy_role_id: 'Copiar',
      copied_role_id: 'Copiado',
      duplicate_role: 'Duplicar',
      delete_role: 'Excluir',
    },
    toast: {
      delete_success: 'Função excluída com sucesso',
      delete_error: 'Falha ao excluir a função',
    },
  },
}) : {}) as Record<string, unknown>;
